import { m } from 'framer-motion';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useRouter } from 'src/routes/hook';
import { useAuthContext } from 'src/auth/hooks';
import { varHover } from 'src/components/animate';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import ManageAssets from 'src/sections/assets/manage-assets-view';
import ManageLiabilities from 'src/sections/liabilities/manage-liabilities-view';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const router = useRouter();

  // const { user } = useMockedUser();

  const { logout, user, avatar } = useAuthContext();

  const popover = usePopover();

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      router.replace('/');
    } catch (error) {
      console.error(error);
    }
  };

  const handleProfile = () => {
    router.push('settings/profile');
  };

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.photoURL}
          alt={user?.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
            background: (theme) => alpha(theme.palette.info.main, 0.08),
          }}
          {...{ children: `${avatar}` }}
        />
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        {/* <Box sx={{ p: 1 }}>
           <Stack
            flexGrow={1}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={{ xs: 0.5, sm: 1 }}
            sx={{ py: 1 }}
            >
            <NotificationsPopover onClick={popover.onClose} />
            <GoalsPopover onClick={popover.onClose} />
            </Stack>
            
            <ScenariosPopover onClick={popover.onClose} /> 
        </Box> */}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleProfile}
          sx={{ m: 1, fontWeight: 'fontWeightBold', overflow: 'hidden' }}
        >
          <Box>
            <Typography variant="subtitle2" noWrap>
              Profile
            </Typography>
            <Typography variant="subtitle2" noWrap>
              {user?.displayName}
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {user?.email}
            </Typography>
          </Box>
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ py: 0.5, px: 1, width: '100%', textAlign: 'left' }}>
          <ManageAssets sx={{ width: '100%', textAlign: 'left' }} />
        </Box>
        <Box sx={{ py: 0.5, px: 1, width: '100%', textAlign: 'left' }}>
          <ManageLiabilities sx={{ width: '100%', textAlign: 'left' }} />
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Logout
        </MenuItem>
      </CustomPopover>
    </>
  );
}
